import { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { testsApi } from '@edulastic/api'
import { test as testConstants } from '@edulastic/constants'
import { getSession, syncTest } from './session'
import { getEditLockSelector, getIsEditBlockedByLockSelector } from './ducks'

/**
 * ASM-985 (F2): the question and passage editors of a test have no read-only mode.
 * - Reached from the test page, the session is already there.
 * - Loaded directly (a bookmark, a refresh), the editor starts or joins the session for the
 *   route's test itself.
 * - If, on entry, the lock does not let this tab edit, go back to the test page, which shows
 *   why. A refusal later, mid-edit, does not navigate: the edits stay on screen (F5).
 */
const EditLockItemGuard = ({ testId, userId, blocked, lock, history }) => {
  const entered = useRef(false)
  const valid = testId && testId !== 'undefined'

  useEffect(() => {
    if (!valid) return undefined
    let cancelled = false
    if (getSession()?.testId !== testId) {
      testsApi
        .getById(testId)
        .then((test) => {
          if (cancelled || !test?._id) return
          const isOwner = test.authors?.some((a) => a._id === userId)
          syncTest({
            test,
            editing:
              !!isOwner && test.status === testConstants.statusConstants.DRAFT,
          })
        })
        .catch(() => {})
    }
    return () => {
      cancelled = true
    }
  }, [testId])

  useEffect(() => {
    if (!valid || entered.current) return
    // wait for this test's session, and for the lock's answer if the tab needs the lock. A
    // retry is an answer: blocked now, so go back to the test page, which says it's retrying
    // (waiting here would let edits start that a later refusal would navigate away from)
    if (!lock.active || `${lock.testId}` !== `${testId}`) return
    if (
      !lock.ended &&
      lock.editing &&
      lock.required &&
      (lock.acquireState === 'none' || lock.acquireState === 'pending')
    ) {
      return
    }
    entered.current = true
    if (blocked) history.replace(`/author/tests/tab/review/id/${testId}`)
  })

  return null
}

export default connect((state) => ({
  blocked: getIsEditBlockedByLockSelector(state),
  lock: getEditLockSelector(state),
}))(EditLockItemGuard)
